<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 800px; height: 600px;" data-cy="case-create-child-procedures-dialog">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="case-create-child-procedures-dialog-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="case-create-child-procedures-dialog-header">
      <div class="section-header-title" data-cy="case-create-child-procedures-dialog-title">
        Select child procedure
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1;" data-cy="case-create-child-procedures-dialog-content">
      <div class="flex-row1" style="margin-left: auto; margin-right: auto; max-height: calc(100% - 40px); flex: 1; align-content: flex-start; justify-content: flex-start;" data-cy="case-create-child-procedures-dialog-procedures-container">
        <button class="tdo-button tdo-save tileButton" *ngFor="let p of data" (click)="clickProcedureSelected(p)" data-cy="case-create-child-procedures-dialog-procedure-btn-{{p.ProcedureName}}">
          {{p.ProcedureName}}
        </button>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="case-create-child-procedures-dialog-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="case-create-child-procedures-dialog-cancel-btn">Cancel</button>
    </div>
  </div>
</div>
